module.exports = __webpack_public_path__ + "static/media/main.54ab987f.png";